import { Component, OnInit } from '@angular/core';
import { DashboardService } from 'src/app/modules/dashboard/services/dashboard.service';

@Component({
  selector: 'app-reports-container',
  templateUrl: './reports-container.component.html',
  styleUrls: ['./reports-container.component.css']
})
export class ReportsContainerComponent implements OnInit {

  programData: any;

  constructor(private dashboardService: DashboardService) { }

  ngOnInit(): void {
this.getProgramActivation();
  }

  getProgramActivation() {
    this.dashboardService.getProgramActivation().subscribe(
      (res: any) => {
        this.programData = JSON.parse(JSON.stringify(res['data']));
        localStorage.setItem('ActivationData',JSON.stringify(this.programData[0]));
      }, (error) => {
        console.log(error);
      }
    );
  }

}
